import { BaseError } from 'make-error';

/**
 * Represents a general {@link ImageCache} error.
 */
class ImageCacheError extends BaseError {
    /**
     * Additional details about the error.
     */
    detail: {
        /**
         * The URI that was attempting to be cached.
         */
        assetUri: string;
    };

    constructor(message = 'ImageCacheError', assetUri: string) {
        if (assetUri) {
            message += ` (${assetUri})`;
        }
        super(message);

        this.detail = {
            assetUri,
        };
    }
}

/**
 * Represents an error when an invalid URI is given.
 */
export class ImageCacheInvalidUriError extends ImageCacheError {
    constructor(message: string, assetUri: string) {
        super(message, assetUri);
    }
}

/**
 * Represents an error when an short circuit occurs.
 */
export class ImageCacheShortCircuitError extends ImageCacheError {
    constructor(message: string, assetUri: string) {
        super(message, assetUri);
    }
}

/**
 * Represents an error when an image is already cached.
 */
export class ImageCacheCachedError extends ImageCacheError {
    constructor(message: string, assetUri: string) {
        super(message, assetUri);
    }
}
